import { Injectable } from '@angular/core';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';

@Injectable({
  providedIn: 'root',
})
export class GlaiKnowledgebaseService {
  constructor(private apiService: APICoreService) {}

  getDistrictKnowledgeBase(districtId: number) {
    return this.apiService.getRequest(`ai/${districtId}/glai-knowledgebase`);
  }
}
